
//
document.querySelectorAll('.slideshow-container').forEach((slider) => {

    //
    let slideIndex         = 1;
    let timeOutID          = null;
    const prevButton       = slider.querySelector('.prev');
    const nextButton       = slider.querySelector('.next');
    const dots             = slider.querySelectorAll('.dot');
    const autoplay         = slider.dataset.sliderAutoplay;
    const interval         = slider.dataset.sliderInterval*1000;

    //display the controls (these are hidden on the off chance this js doesn't load)
    slider.querySelector('.slide-pagination').style.display = 'flex';

    //
    showSlides(slideIndex, slider);

    //
    slider.querySelectorAll('.slide').forEach((slide) => {

        //
        if (slide.querySelector('.slide-background-video video') == null) {
            return;
        }

        //
        const video       = slide.querySelector('.slide-background-video video');
        const videoSource = slide.querySelector('.slide-background-video video source[type="video/mp4"]');

        //these need to be initialised only if there is a video
        const videoSources = JSON.parse(video.dataset.sources);

        //watch for the video element being resized
        const resizeObserver = new ResizeObserver((entries) => {
            for (let i = 0; i < videoSources.length; i++) {
                if (entries[0].contentBoxSize[0].inlineSize <= videoSources[i][0] || (videoSources.length - 1) == i) {

                    //don't reload the video if it's already the loaded one
                    if ((new URL(videoSource.src)).pathname == (new URL(videoSources[i][1], 'https://www.nrla.org.uk')).pathname) {
                        break;
                    }

                    //
                    videoSource.src = videoSources[i][1];
                    video.load();

                    //
                    break;

                }
            }
        });

        //
        resizeObserver.observe(video);

    });

    //
    function startAutoplay() {
        timeOutID = setInterval(() => {
            showSlides(slideIndex += 1, slider);
        }, interval);
    }

    //
    if (autoplay == 1) {
        startAutoplay();
    }

    //
    if (prevButton !== null) {
        prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            showSlides(slideIndex += -1 , slider);
            if (autoplay == 1) {
                clearInterval(timeOutID);
                startAutoplay();
            }
        });
    }

    //
    if (nextButton !== null) {
        nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            showSlides(slideIndex += 1, slider);
            if (autoplay == 1) {
                clearInterval(timeOutID);
                startAutoplay();
            }
        });
    }

    // Add click event listener to each dot
    dots.forEach((dot, index) => {
        dot.addEventListener('click', (event) => {
            event.preventDefault();
            showSlides(slideIndex = index+1, slider);
            if (autoplay == 1) {
                clearInterval(timeOutID);
                startAutoplay();
            }
        });
    });

    //
    function showSlides(n, slider) {

        //
        let i;
        let slides = slider.getElementsByClassName('slide');
        let dots = slider.getElementsByClassName('dot');

        //
        if (n > slides.length) {
            slideIndex = 1
        }

        //
        if (n < 1) {
            slideIndex = slides.length
        }

        //
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = 'none';
        }

        //
        for (i = 0; i < dots.length; i++) {
            dots[i].classList.remove('active');
        }

        //
        slides[slideIndex - 1].style.display = 'flex';

        //attempt to set the active dot if there are dots on the slider
        if (dots.length > 0 ) {
            dots[slideIndex - 1].classList.add('active');
        }

        //updating the color for the controls on the current slide
        const controlsColor = slides[slideIndex - 1].dataset.controlsColor;
        const activeDotColor = slides[slideIndex - 1].dataset.activeDotColor;

        //
        slider.style.setProperty('--controlsColor', controlsColor);
        slider.style.setProperty('--dotActiveColor', activeDotColor);

    }

});
